jQuery(document).ready(function ($) {
	//   $('.testSelAll').change(function(){
	//     $('.testSelAll option:selected').each(function(i) {
	//     console.log($(this).val(), $('body .custom-category li a[href="'+$(this).val()+'"]'));
	//       $('.custom-category li a[href="'+$(this).val()+'"]').trigger('click');
	//   });
	// });

	$("body").on("click", ".add-multiple", function () {
		//     setTimeout(function(){

		$(".desktop-add-all-wrap .add-to-cart-btn input").trigger("click");
		//   	}, 1000)
	});

	$("body").on("click", ".add-multiple-mob.hide_on_desk", function () {
		$(".mobile-add-all-wrap .add-to-cart-btn input").trigger("click");
	});

	$("#bar-add-to-cart").click(function () {
		$("[data-product-form] .product-form__cart-submit").first().trigger("click");
		//     var soldOutText = $('.product-form__cart-submit span').text();
	});

	$("#nutrition-tab").click(function () {
		$(".nutrition-popup").addClass("show");
	});
	$(".close").click(function () {
		$(".nutrition-popup").removeClass("show");
	});

	$(window).scroll(function () {
		var scroll = $(window).scrollTop(),
			headerHeight = $(".header-wrap").height();
		if (scroll >= headerHeight) {
			$("body").addClass("header-sticky");
		} else {
			$("body").removeClass("header-sticky");
		}
	});

	/*newsletter popup*/
	$(window).scroll(function () {
		if ($(this).scrollTop() > 450) {
			$(".newsletter-popup1").fadeIn("700");
			$(".newsletter-popup1").addClass("newsletter-active");
		} else {
			$(".newsletter-popup1").fadeOut("700");
			$(".newsletter-popup1").removeClass("newsletter-active");
		}
	});

	/*home page categories*/

	/*home page categories*/
	jQuery("body .scroll").on("click", function (event) {
		event.preventDefault();
		var $anchor = jQuery(this);
		jQuery("html, body")
			.stop()
			.animate(
				{
					scrollTop: jQuery($anchor.attr("href")).offset().top,
				},
				2000,
				"swing"
			);
	});
	$(window).scroll(function () {
		if ($(this).scrollTop() > 300) {
			$(".back-to-top").fadeIn();
			$(".product-bar").removeClass("d-none d-md-block");
		} else {
			$(".back-to-top").fadeOut();
			$(".product-bar").addClass("d-none d-md-block");
		}
	});

	function stickyHeader() {
		bannerHeight = $("#shopify-section-product-template").height();
	}
	$(window).resize(function () {
		stickyHeader();
	});
	stickyHeader();
	if ($(window).width() < 768 && !$(".product-bar").hasClass("stick")) {
		$(".product-bar").addClass("stick");
	} else {
		$(window).scroll(function () {
			if ($(window).width() > 767) {
				if ($(".product-single__meta").length) {
					add_to_cart_offset = $(".product-single__meta").offset().top;
					add_to_cart_ht = $(".product-single__meta").height();
					header_wrap_ht = $(".header-wrap").height();
					add_to_cart_offset =
						add_to_cart_offset + add_to_cart_ht - header_wrap_ht;
					//console.log(add_to_cart_offset, add_to_cart_ht, add_to_cart_offset);
					if (
						$(this).scrollTop() > add_to_cart_offset &&
						!$(".product-bar").hasClass("stick")
					) {
						$(".product-bar").addClass("stick");
						$("body").addClass("product-bar-active");
					} else if ($(this).scrollTop() <= add_to_cart_offset) {
						$(".product-bar").removeClass("stick");
						$("body").removeClass("product-bar-active");
					}
				}
			}
		});
	}

	$(window).scroll(function () {
		if ($(window).width() < 767) {
			if ($(".product-single__meta").length) {
				add_to_cart_offset = $(".product-single__meta").offset().top;
				add_to_cart_ht = $(".product-single__meta").height();
				header_wrap_ht = $(".header-wrap").height();
				add_to_cart_offset =
					add_to_cart_offset + add_to_cart_ht - header_wrap_ht;
				//console.log(add_to_cart_offset, add_to_cart_ht, add_to_cart_offset);
				if (
					$(this).scrollTop() > add_to_cart_offset &&
					!$(".product-bar").hasClass("stick")
				) {
					$(".product-bar").addClass("stick");
					$("body").addClass("product-bar-active");
				} else if ($(this).scrollTop() <= add_to_cart_offset) {
					$(".product-bar").removeClass("stick");
					$("body").removeClass("product-bar-active");
				}
			}
		}
	});

	// Js for SVG
	jQuery("img.svg").each(function () {
		var $img = jQuery(this);
		var imgID = $img.attr("id");
		var imgClass = $img.attr("class");
		var imgURL = $img.attr("src");
		jQuery.get(
			imgURL,
			function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = jQuery(data).find("svg");

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== "undefined") {
					$svg = $svg.attr("id", imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== "undefined") {
					$svg = $svg.attr("class", imgClass + " replaced-svg");
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr("xmlns:a");

				// Check if the viewport is set, else we gonna set it if we can.
				if (
					!$svg.attr("viewBox") &&
					$svg.attr("height") &&
					$svg.attr("width")
				) {
					$svg.attr(
						"viewBox",
						"0 0 " + $svg.attr("height") + " " + $svg.attr("width")
					);
				}

				// Replace image with new SVG
				$img.replaceWith($svg);
			},
			"xml"
		);
	});
	$(window).on("resize", function () {
		if ($(window).width() < 767) {
			/*home make-it-slider slider*/
			if (!$(".related-products-inner .row").hasClass("slick-initialized")) {
				$(".related-products-inner .row").slick({
					infinite: true,
					autoplay: false,
					slidesToShow:
						$(window).width() > 992 ? 4 : $(window).width() > 768 ? 3 : 2,
					arrows: true,
					slidesToScroll: 2,
					dots: true,
					centerMode: true,
					speed: 300,
					customPaging: function (slider, i) {
						return i + 1;
					},
					responsive: [
						{
							breakpoint: 992,
							settings: {
								slidesToShow: 2,
							},
						},
						{
							breakpoint: 768,
							settings: {
								slidesToShow: 2,
								arrows: false,
							},
						},
					],
				});
			}
		} else {
			if ($(".related-products-inner .row").hasClass("slick-initialized")) {
				$(".related-products-inner .row").slick("unslick");
			}
		}
	});
	if ($(window).width() < 767) {
		$(".related-products-inner .row").slick({
			infinite: true,
			autoplay: false,
			slidesToShow:
				$(window).width() > 992 ? 4 : $(window).width() > 768 ? 3 : 2,
			arrows: true,
			slidesToScroll: 1,
			dots: true,
			centerMode: true,
			speed: 300,
			customPaging: function (slider, i) {
				return i + 1;
			},
			responsive: [
				{
					breakpoint: 992,
					settings: {
						slidesToShow: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 2,
						arrows: false,
					},
				},
			],
		});
	}
	/*home make-it-slider slider*/
	$(".section-make-it .make-it-slider").slick({
		infinite: true,
		autoplay: true,
		slidesToShow: 4,
		arrows: true,
		slidesToScroll: 1,
		dots: true,
		centerMode: true,
		speed: 300,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					arrows: true,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
				},
			},
		],
	});
	$(window).on("resize", function () {
		if ($(window).width() < 991) {
			if (
				!$(
					".template-product .product-single__media-group .mobile-slider-images"
				).hasClass("slick-initialized")
			) {
				$(
					".template-product .product-single__media-group .mobile-slider-images"
				).slick({
					infinite: true,
					autoplay: false,
					arrows: false,
					slidesToScroll: 1,
					dots: false,
					centerMode: false,
					speed: 300,
					adaptiveHeight: true,
				});
			}
		} else {
			if (
				$(
					".template-product .product-single__media-group .mobile-slider-images"
				).hasClass("slick-initialized")
			) {
				$(
					".template-product .product-single__media-group .mobile-slider-images"
				).slick("unslick");
			}
		}
	});
	if ($(window).width() < 991) {
		if (
			!$(
				".template-product .product-single__media-group .mobile-slider-images"
			).hasClass("slick-initialized")
		) {
			$(
				".template-product .product-single__media-group .mobile-slider-images"
			).slick({
				infinite: true,
				autoplay: false,
				arrows: false,
				slidesToScroll: 1,
				dots: true,
				centerMode: false,
				speed: 300,
				adaptiveHeight: true,
			});
		}
	}
	/*product-signle-slider slider*/
	$(".product-single-recipe-slider").slick({
		infinite: true,
		autoplay: true,
		slidesToShow: $(window).width() > 992 ? 4 : $(window).width() > 768 ? 3 : 2,
		arrows: true,
		slidesToScroll: 1,
		dots: true,
		centerMode: true,
		speed: 300,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	});
    
	$(".image-slider").slick({
		infinite: true,
		autoplay: true,
		slidesToShow: 5,
        slidesToScroll: 1,
		arrows: true,
		
		dots: false,
		variableWidth: false,
		centerMode: false,
		speed: 300,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	});
	/* Header */
	/*sub menu open*/

	$("body").on("click", "nav .main_menu", function (e) {
		$(".main_menu").removeClass("active");
		$(this).addClass("active");
	});

	/* Mobile drawer: only the top-level parent <a> opens/closes its submenu.
	   iOS: distinguish tap from scroll; stop submenu touches from toggling parents; suppress ghost click after touch. */
	(function () {
		var MOBILE_NAV_MAX = 991;
		function mobileNavMatches() {
			return window.matchMedia("(max-width: " + MOBILE_NAV_MAX + "px)").matches;
		}
		var submenuTouchSelector =
			"nav .main-submenu-container, nav .main-submenu-container *, nav .recipes-submenu-container, nav .recipes-submenu-container *";

		var touchStart = { x: 0, y: 0, t: 0, target: null };
		var suppressClickUntil = 0;

		function isTap(e) {
			var ch = e.originalEvent && e.originalEvent.changedTouches;
			if (!ch || !ch.length) return true;
			var end = ch[0];
			var dt = Date.now() - touchStart.t;
			var dx = Math.abs(end.clientX - touchStart.x);
			var dy = Math.abs(end.clientY - touchStart.y);
			return dt < 600 && dx < 12 && dy < 12;
		}

		$(document).on(
			"touchstart.headerMobileNav",
			"nav ul.header-nav-list > li.items-has-children > a",
			function (e) {
				if (!mobileNavMatches() || !$("body").hasClass("header-open")) return;
				var t = e.originalEvent && e.originalEvent.touches;
				if (t && t.length) {
					touchStart.x = t[0].clientX;
					touchStart.y = t[0].clientY;
					touchStart.t = Date.now();
					touchStart.target = e.currentTarget;
				}
			}
		);

		$(document).on(
			"touchend.headerMobileNav",
			"nav ul.header-nav-list > li.items-has-children > a",
			function (e) {
				if (!mobileNavMatches() || !$("body").hasClass("header-open")) return;
				if (touchStart.target !== e.currentTarget) return;
				if (!isTap(e)) return;
				e.preventDefault();
				e.stopPropagation();
				suppressClickUntil = Date.now() + 500;
				var $li = $(this).closest("li.items-has-children");
				var opening = !$li.hasClass("open-menu");
				if (opening) {
					$li
						.siblings("li.items-has-children")
						.removeClass("open-menu")
						.removeClass("active");
					$li.addClass("open-menu");
				} else {
					$li.removeClass("open-menu").removeClass("active");
				}
			}
		);

		$(document).on(
			"click.headerMobileNav",
			"nav ul.header-nav-list > li.items-has-children > a",
			function (event) {
				if (!mobileNavMatches() || !$("body").hasClass("header-open")) return;
				if (Date.now() < suppressClickUntil) {
					event.preventDefault();
					event.stopPropagation();
					return;
				}
				event.preventDefault();
				event.stopPropagation();
				var $li = $(this).closest("li.items-has-children");
				var opening = !$li.hasClass("open-menu");
				if (opening) {
					$li
						.siblings("li.items-has-children")
						.removeClass("open-menu")
						.removeClass("active");
					$li.addClass("open-menu");
				} else {
					$li.removeClass("open-menu").removeClass("active");
				}
			}
		);

		/* Submenu / nested links: never let those interactions hit the parent row toggle logic */
		$(document).on(
			"touchstart.headerMobileNav touchend.headerMobileNav click.headerMobileNav",
			submenuTouchSelector,
			function (e) {
				if (!mobileNavMatches() || !$("body").hasClass("header-open")) return;
				e.stopPropagation();
			}
		);
	})();
	$("body").on("click", ".js-nav-trigger", function (event) {
		$("body").toggleClass("header-open");
	});
	$("body").on("click", ".announcement-bar .btn-close", function (event) {
		$(".announcement-bar").fadeOut("500");
	});
	/*about page read more read less*/
	$("body").on("click", ".read-more", function (event) {
		$(this).parents(".section-content-wrap").addClass("open");
	});
	$("body").on("click", ".read-less", function (event) {
		$(this).parents(".section-content-wrap").removeClass("open");
	});
	/*shop page categories toggle*/
	$("body").on("click", ".toggle-category a", function (event) {
		$(".categories").toggleClass("open");
	});

	/*newsletter popup*/
	/* Shopping cart open */
	jQuery(".shopping-cart").click(function () {
		jQuery(".cart-popup-wrapper").toggleClass("cart-popup-wrapper--hidden");
	});
	jQuery(".close").click(function () {
		jQuery(".cart-popup-wrapper").addClass("cart-popup-wrapper--hidden");
	});
	/* Shopping cart end */
	/* Submenu Open start */
	jQuery(".menu-item-has-children").click(function () {
		$(this).toggleClass("open-menu");
	});
	/* Submenu Open end */
	$(document).on("click", ".cart_icon", function (event) {
		event.preventDefault();
		$("body").addClass("header-minicart-open1");
	});
	$(document).on("click", ".cart-close", function (event) {
		$("body").removeClass("header-minicart-open1");
		$("body").removeClass("header-minicart-open");
	});
	$("body").on("click", ".add-message", function () {
		//     $('.cart-gift-message').toggle();

		$(".gift-msg-container").toggle();
	});

	$(document).on("click", ".minus", function () {
		var qty = parseInt($(this).next(".input-number").val());
		if (qty != 1) {
			qty -= 1;
		}

		if ($(this).hasClass("product-detail")) {
			$(".product-input-number").val(qty);
			if ($(this).hasClass("cart-page"))
				$(this).siblings(".qty").trigger("change");
		} else if (!$(this).hasClass("cart-quantity-selector")) {
			$(this).next(".input-number").val(qty);
		}
	});

	$(document).on("click", ".plus", function () {
		var qty = parseInt($(this).prev(".input-number").val());
		qty += 1;
		if ($(this).hasClass("product-detail")) {
			$(".product-input-number").val(qty);
			if ($(this).hasClass("cart-page"))
				$(this).siblings(".qty").trigger("change");
		} else if (!$(this).hasClass("cart-quantity-selector")) {
			$(this).prev(".input-number").val(qty);
		}
	});

	$("body").on("focus", "#gift_note", function () {
		$(this).removeAttr("placeholder");
	});

	$("body").on("blur", "#gift_note", function () {
		$(this).attr(
			"placeholder",
			"Type your message here, but avoid emojis and special characters."
		);
	});
	$(".sumo-select").SumoSelect();

	function matchheight_content() {
		setTimeout(function () {
			$(".swym-item-grid .swym-item .swym-information").matchHeight({
				byRow: true,
			});
		}, 5000);
		$(".section-about-press-content").matchHeight({
			byRow: true,
		});
		$(
			".section-about-press-content .press-col-layout .content-wrap"
		).matchHeight({
			byRow: true,
		});
		$(
			".section-about-press-content .press-col-layout .content-wrap p"
		).matchHeight({
			byRow: true,
		});
	}
	matchheight_content();

	jQuery(window).resize(function () {
		matchheight_content();
	});

    $('.visit-content .card-header').each(function(index, elem){
        $(this).click(function(){
            $('.visit-images .image').removeClass('active');
            $('.visit-images .image').eq(index).addClass('active');
        });
    });

	$("body .section-related-recipes .make-it-slider").slick({
		infinite: true,
		autoplay: false,
		slidesToShow: 4,
		arrows: true,
		slidesToScroll: 1,
		dots: true,
		variableWidth: false,
		centerMode: false,
		speed: 300,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				},
			},
		],
	});
	if ($(window).width() < 768) {
		$("body .recipe-wrapper-left .product_row.make-it-slider").slick({
			infinite: true,
			autoplay: false,
			slidesToShow: 1,
			arrows: false,
			slidesToScroll: 1,
			dots: true,
			centerMode: false,
			speed: 300,
			customPaging: function (slider, i) {
				return i + 1;
			},
		});
	}

	var cur_hash = window.location.hash;
	if (cur_hash == "#recipe") {
		var pre_url = document.referrer;
		pre_url = pre_url.split("pages/");
		var page_handle = pre_url[1];
		var page_title = "";
		$.getJSON("/pages/" + page_handle, function (data) {
			page_title = data.page.title;
			if (page_title != "") {
				$("#append_url").after(
					'<a href="/pages/' +
						page_handle +
						'" title="' +
						page_handle +
						'">' +
						page_title +
						"</a>"
				);
				$("#append_url").show();
			}
		});
	}

	function menu_scroll() {
		var type = window.location.hash.substr(1);
		if (type == "headingTwo") {
			$("html, body").animate(
				{
					scrollTop: $(".scroll-top-div-pos").offset().top,
				},
				500
			);
			$("#shipping .card-header button").trigger("click");
		} else if (type == "headingThree") {
			$("html, body").animate(
				{
					scrollTop: $(".scroll-top-div-pos").offset().top + -40,
				},
				500
			);
			if ($("#careers .card-header button").hasClass("collapsed"))
				$("#careers .card-header button").trigger("click");
		} else if (type == "privacy") {
			$("html, body").animate(
				{
					scrollTop: $(".scroll-top-div-pos").offset().top + -40,
				},
				500
			);
			$("#privacy .card-header button").trigger("click");
		}
	}
	menu_scroll();

	$("body").on("click", '.footer-links-col a[href="#hash"]', function () {
		menu_scroll();
	});
	//review text displayed
	$("body").on("click", ".stamped-summary-actions-newreview", function () {
		if ($(".new-review-form").is(":visible")) {
			$("body .custom-msg").removeClass("hide");
			$("body .stamped-form-contact-email").find("label").text("Email Address");
			$("body .stamped-form-review-title").find("label").text("Review Title");
			$("body .stamped-form-review-body")
				.find("label")
				.text("Body of Review (1500)");
			$("body .stamped-form-input-textarea").attr(
				"placeholder",
				"Write your comments here"
			);
		} else {
			$("body .custom-msg").addClass("hide");
		}
	});

	window.onhashchange = function () {
		menu_scroll();
	};
	//for header sticky
	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
		if (scroll >= 120) {
			$("body").addClass("header-sticky-new");
		} else {
			$("body").removeClass("header-sticky-new");
		}
	});

	function initCuratedReviewsSlider() {
		var $slider = $(".js-curated-reviews-slider");
		if (!$slider.length) {
			return;
		}

		var isMobile = $(window).width() < 768;

		if (isMobile) {
			if (!$slider.hasClass("slick-initialized")) {
				$slider.slick({
					infinite: true,
					autoplay: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					centerMode: false,
					speed: 300,
				});
			}
		} else if ($slider.hasClass("slick-initialized")) {
			$slider.slick("unslick");
		}
	}

	initCuratedReviewsSlider();

	var curatedReviewsResizeTimer;
	$(window).on("resize", function () {
		clearTimeout(curatedReviewsResizeTimer);
		curatedReviewsResizeTimer = setTimeout(initCuratedReviewsSlider, 200);
	});

	$(document).on("shopify:section:load", function (event) {
		if ($(event.target).find(".js-curated-reviews-slider").length) {
			initCuratedReviewsSlider();
		}
	});

	// Customer Contact Form Toggle
	$('body').on('click', 'a[href="#?show-form"]', function(e) {
		e.preventDefault();
		
		var $form = $('.customer-contact-form');
		var $button = $(this);
		
		// Show form
		$form.addClass('show-form');
		
		// Hide the button when form is shown
		$button.hide();
	});
});
/*Ready function end*/
